import React, { useContext } from "react";
import ThemeContext from "~/contexts/ThemeContext";

type ChevronDownProps = {
  className?: string;
  color?: string;
};

const ChevronDown: React.FC<ChevronDownProps> = ({ className, color }) => {
  const { template } = useContext(ThemeContext);
  const iconColor = color || template.global.icon.colour;

  return (
    <svg
      className={className}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25 9.375L12.5 15.625L18.75 9.375"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronDown;
